import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "range__slider__container" }
const _hoisted_2 = { class: "range__slider__progress" }
const _hoisted_3 = ["min", "max", "step"]
const _hoisted_4 = ["min", "max", "step"]
const _hoisted_5 = ["min", "max", "step"]
const _hoisted_6 = ["min", "max", "step"]
const _hoisted_7 = { class: "slider" }
const _hoisted_8 = {
  "aria-label": "minmax heading",
  class: "fw-ic-jb range__slider__minmax"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  "aria-label": "cta buttons",
  class: "cta__btn rangeslider__ctabtn"
}

import { ref, onBeforeMount, onMounted, toRefs } from "vue";
import { formatPrice } from "@/core";
import { SliderChange } from "@/constant";
import { isMobile, isTablet, isFirefox } from "mobile-device-detect";


export default /*@__PURE__*/_defineComponent({
  __name: 'RangeSlider',
  props: {
    max: {},
    min: {},
    showMinRangeOnSlider: {},
    showMaxRangeOnSlider: {}
  },
  emits: ["clearPriceFilter", "applyPriceFilter", "updatePriceRangeMobile", "closePriceRange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { max, min, showMinRangeOnSlider, showMaxRangeOnSlider } = toRefs(props);

const emit = __emit;

const sliderMinValue = ref(0);
const sliderMaxValue = ref(0);
const formattedSliderMinValue = ref("");
const formattedSliderMaxValue = ref("");
const step = SliderChange;
const zIndexLeft = ref(9);
const zIndexRight = ref(20);
const hasMobile = !!(isMobile && !isTablet);
const isPriceChanged = ref(false);

const minSlider = ref<HTMLInputElement | null>(null);
const maxSlider = ref<HTMLInputElement | null>(null);
const range = ref<HTMLDivElement | null>(null);
const range1 = ref<HTMLDivElement | null>(null);
const left = ref<HTMLDivElement | null>(null);
const right = ref<HTMLDivElement | null>(null);

onBeforeMount(() => {
  sliderMinValue.value = showMinRangeOnSlider.value;
  sliderMaxValue.value = showMaxRangeOnSlider.value;
});

onMounted(() => {
  changeLeft();
  changeRight();
});

const updateLeftPercentage = (percentageValue: number) => {
  if (percentageValue > 0 && percentageValue < 80 && !hasMobile) {
    percentageValue -= 4;
  } else if (percentageValue > 80 && !hasMobile) {
    percentageValue -= 8;
  } else if (percentageValue > 80 && hasMobile) {
    percentageValue -= 2;
  }
  return percentageValue;
};

const updateRightPercentage = (percentageValue: number) => {
  if (percentageValue > 0 && hasMobile) {
    percentageValue -= 4;
  } else if (percentageValue > 80 && !hasMobile) {
    percentageValue -= 4;
  }
  return percentageValue;
};

const updateZIndex = (leftIdx: number, rightIdx: number) => {
  zIndexLeft.value = leftIdx;
  zIndexRight.value = rightIdx;

  if (hasMobile) {
    emit("updatePriceRangeMobile", {
      minValue: sliderMinValue.value,
      maxValue: sliderMaxValue.value,
    });
  }
  if (isPriceChanged.value) {
    emit("applyPriceFilter", {
      minValue: sliderMinValue.value,
      maxValue: sliderMaxValue.value,
    });
  }
};

const changeLeft = () => {
  if (!minSlider.value || !maxSlider.value) return;

  minSlider.value.value = String(
    Math.min(Number(minSlider.value.value), Number(maxSlider.value.value) - step)
  );
  sliderMinValue.value = Number(minSlider.value.value);

  let percentageValue = ((sliderMinValue.value - min.value) / (max.value - min.value)) * 100;
  percentageValue = updateLeftPercentage(percentageValue);

  if (range.value) range.value.style.width = percentageValue + "%";
  if (left.value) left.value.style.left = percentageValue + "%";

  formattedSliderMinValue.value = formatPrice(sliderMinValue.value);

  if (sliderMinValue.value > min.value && !isPriceChanged.value) {
    isPriceChanged.value = true;
  }
  updateZIndex(20, 9);
};

const changeRight = () => {
  if (!minSlider.value || !maxSlider.value) return;

  maxSlider.value.value = String(
    Math.max(Number(minSlider.value.value) + step, Number(maxSlider.value.value))
  );
  sliderMaxValue.value = Number(maxSlider.value.value);

  let percentageValue =
    ((Number(maxSlider.value.max) - sliderMaxValue.value) /
      (Number(minSlider.value.max) - Number(minSlider.value.min))) *
    100;
  percentageValue = updateRightPercentage(percentageValue);

  if (range1.value) range1.value.style.width = percentageValue + "%";
  if (right.value) right.value.style.left = 100 - percentageValue + "%";

  formattedSliderMaxValue.value = formatPrice(sliderMaxValue.value);

  if (sliderMaxValue.value < max.value && !isPriceChanged.value) {
    isPriceChanged.value = true;
  }
  updateZIndex(9, 20);
};

const setToInitialRangeSlider = () => {
  sliderMinValue.value = min.value;
  sliderMaxValue.value = max.value;

  if (minSlider.value) minSlider.value.value = String(min.value);
  if (maxSlider.value) maxSlider.value.value = String(max.value);

  changeLeft();
  changeRight();
  emit("clearPriceFilter", { minShow: 0, maxShow: 0 });
  isPriceChanged.value = false;
};

const calculate = () => {
  emit("closePriceRange");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isMobile))
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "range",
            id: "input-left",
            ref_key: "minSlider",
            ref: minSlider,
            min: _unref(min),
            max: _unref(max),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sliderMinValue).value = $event)),
            step: _unref(step),
            style: _normalizeStyle({ zIndex: zIndexLeft.value }),
            class: _normalizeClass({ changePointerEvent: !_unref(isFirefox) }),
            onTouchmove: changeLeft,
            onTouchend: changeLeft
          }, null, 46, _hoisted_3)), [
            [_vModelText, sliderMinValue.value]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "range",
            id: "input-left",
            ref_key: "minSlider",
            ref: minSlider,
            min: _unref(min),
            max: _unref(max),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sliderMinValue).value = $event)),
            step: _unref(step),
            style: _normalizeStyle({ zIndex: zIndexLeft.value }),
            class: _normalizeClass({ changePointerEvent: !_unref(isFirefox) }),
            onMousemove: changeLeft,
            onMouseout: changeLeft
          }, null, 46, _hoisted_4)), [
            [_vModelText, sliderMinValue.value]
          ]),
      (_unref(isMobile))
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "range",
            id: "input-right",
            ref_key: "maxSlider",
            ref: maxSlider,
            min: _unref(min),
            max: _unref(max),
            step: _unref(step),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sliderMaxValue).value = $event)),
            style: _normalizeStyle({ zIndex: zIndexRight.value }),
            class: _normalizeClass({ changePointerEvent: !_unref(isFirefox) }),
            onTouchmove: changeRight,
            onTouchend: changeRight
          }, null, 46, _hoisted_5)), [
            [_vModelText, sliderMaxValue.value]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 3,
            type: "range",
            id: "input-right",
            ref_key: "maxSlider",
            ref: maxSlider,
            min: _unref(min),
            max: _unref(max),
            step: _unref(step),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sliderMaxValue).value = $event)),
            style: _normalizeStyle({ zIndex: zIndexRight.value }),
            class: _normalizeClass({ changePointerEvent: !_unref(isFirefox) }),
            onMousemove: changeRight,
            onMouseout: changeRight
          }, null, 46, _hoisted_6)), [
            [_vModelText, sliderMaxValue.value]
          ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "track" }, null, -1)),
        _createElementVNode("div", {
          class: "range",
          ref_key: "range",
          ref: range
        }, null, 512),
        _createElementVNode("div", {
          class: "range1",
          ref_key: "range1",
          ref: range1
        }, null, 512),
        _createElementVNode("div", {
          class: "thumb left",
          ref_key: "left",
          ref: left
        }, null, 512),
        _createElementVNode("div", {
          class: "thumb right",
          ref_key: "right",
          ref: right
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "range__slider__minmaxtitle" }, "Min", -1)),
        _createElementVNode("input", {
          class: "range__slider__input",
          type: "text",
          ref: "minText",
          value: formattedSliderMinValue.value,
          readonly: ""
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "range__slider__minmaxtitle text-right" }, "Max", -1)),
        _createElementVNode("input", {
          class: "range__slider__input",
          type: "text",
          ref: "maxText",
          value: formattedSliderMaxValue.value,
          readonly: ""
        }, null, 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (!hasMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "cta__btntext",
            onClick: setToInitialRangeSlider
          }, " Clear "))
        : _createCommentVNode("", true),
      (!hasMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "cta__btnsolid",
            onClick: calculate
          }, " Apply "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})